import React, { useRef, useState, useEffect } from 'react';
import TablaUsuariosApp from './tablaUsuriosApp';

export const UsuariosApp = (props) => {

    return (
        <div className='container-fluid rounded p-0 m-0'>
        <div className='container-fluid w-100 h-100 p-0 m-0'>
               <TablaUsuariosApp/>
           </div>

        </div>

    );
}


// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/usuariosApp.js